import { alpha } from '@material-ui/core/styles/colorManipulator';

export default (theme) => ({
  container: {
    border: `1px solid ${theme.palette.borderColor.table}`,
    borderRadius: 5,
  },
  containerStriped: {
    border: 0,
    borderRadius: 0,
  },
  head: {
    background: alpha(theme.palette.primary.main, 0.08),
  },
  headStriped: {
    background: 'transparent',
  },
  headCell: {
    padding: '10px 25px',
    fontSize: 12,
    color: theme.palette.textColor.tableHead,
    whiteSpace: 'nowrap',
  },
  headCellStriped: {
    color: theme.palette.textColor.secondary,
  },
  sortLabel: {
    // Icon parked outside the label so a sortable header keeps the width of a plain one.
    '& .MuiTableSortLabel-icon': {
      position: 'absolute',
      left: '100%',
    },
  },
  row: {
    '&.MuiTableRow-hover:hover, &.Mui-selected, &.Mui-selected:hover': {
      background: alpha(theme.palette.primary.main, 0.09),
    },
  },
  rowStriped: {
    '&:nth-of-type(even)': {
      background: theme.palette.background.lightBlue,
    },
  },
  cell: {
    padding: '16px 25px',
    fontSize: 14,
    borderBottom: `1px solid ${theme.palette.borderColor.table}`,
  },
  cellDense: {
    padding: '8px 12px',
  },
  // Declared after `cellDense`: JSS emits rules in key order, so at equal specificity the later one wins.
  headCellDense: {
    padding: '6px 12px',
  },
  cellStriped: {
    borderBottom: 0,
  },
  progress: {
    padding: 0,
    borderBottom: 0,
  },
  placeholder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4, 0),
    color: theme.palette.textColor.secondary,
  },
});
